import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../../../globals';
import { OdsServices } from '../../../../services';
import { OdsConfigMenuCreatePage } from '../ods-config-menu-create';
import { OdsViewPage } from '../../../../ods-view/ods-view';

/**
 * Generated class for the OdsConfigMenuCreateFinishPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-ods-config-menu-create-finish',
  templateUrl: 'ods-config-menu-create-finish.html',
})
export class OdsConfigMenuCreateFinishPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public toastCtrl: ToastController,
    public translate: TranslateService,
    public odsServices: OdsServices) {
  }

  newSection() {
    this.navCtrl.push(OdsConfigMenuCreatePage, {
      update_state: false
    });
  }

  finish() {
    this.odsServices.show_config_tab = true;
    this.navCtrl.setRoot(OdsViewPage);
  }
}


// WEBPACK FOOTER //
// ./src/pages/ods/ods-config/ods-config-menu/ods-config-menu-create/ods-config-menu-create-finish/ods-config-menu-create-finish.ts